import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { RouterModule } from '@angular/router';
import { ApiClientService } from "@shared/_services/api-client.service";
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';

@Component({
  selector: 'app-user-details',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    PreloaderComponent
  ],
  providers: [],
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.css'
})
export class UserDetailsComponent {

  public loading: boolean = false;
  public hasError: boolean = false;
  public errorMsg: string = '';
  public userDetails: any = {};
  public userDevices: any[] = [];
  public userId: string = '';
  public totalItems: number = 0;
  public currentPage: number = 1;
  public pageSize: number = 10;
  selectedTab: string = 'profile';
  public urlPath: string = '';

  constructor(private _apiClientService: ApiClientService,) {

    this.urlPath = window.location.href;
    this.userId = this.urlPath.split('/')[5];
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.userId = this.urlPath.split('/')[5];

    this.getUserDetails();
  }

  public async getUserDetails() {
    this.loading = true;
    (await this._apiClientService.readAllApiService(`admin/itt-user/${this.userId}/detail`)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            //console.log("Users Details ", event.body);
            let data = event.body;
            //if (status == 200) {

            this.userDetails = data;
            this.userDevices = data.devices;
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

}
